/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useWizardContext } from '../context/WizardContext';
import SelectionCard from '../SelectionCard';
import { getWizardIcon } from '../icons/wizardIcons';

function VisitFrequencyStep() {
    const { frequencyAnswer, setVisitFrequency } = useWizardContext();

    return (
        <div className="wizard-step-cards">
            <SelectionCard
                id="frequency-multiple"
                label="I plan to visit multiple locations"
                illustration={<img src={getWizardIcon('multiple-locations')} alt="" />}
                isSelected={frequencyAnswer === 'multiple'}
                onSelect={() => setVisitFrequency('multiple')}
            />
            <SelectionCard
                id="frequency-single"
                label="I plan to visit one location"
                illustration={<img src={getWizardIcon('single-location')} alt="" />}
                isSelected={frequencyAnswer === 'single'}
                onSelect={() => setVisitFrequency('single')}
            />
        </div>
    );
}

export default VisitFrequencyStep;
